//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Helpers
import { classes } from "../../../helpers/classname"

const {
  Container,
  ImageWrapper,
  TextWrapper,
  Title,
  Subtitle,
  badImage,
} = style

const Block = ({ img, title, subtitle, end }) => {
  return (
    <div className={Container}>
      <div className={classes(ImageWrapper, end ? badImage : "")}>
        <img src={img} alt={title}></img>
      </div>
      <div className={TextWrapper}>
        <h4 className={Title}>{title}</h4>
        <h5 className={Subtitle}>{subtitle}</h5>
      </div>
    </div>
  )
}

export default Block
